import type { IInstrumentLiveEditState, IRepublishInstrumentResult } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { instrumentApiPath } from '@/features/instruments/infra/instrumentPaths'

export function instrumentLiveEditPath(instrumentId: string): string {
  return instrumentApiPath(instrumentId, '/live-edit')
}

export function instrumentRepublishPath(instrumentId: string): string {
  return instrumentApiPath(instrumentId, '/republish')
}

/** BFP-1142 — opens (or resumes) the pending revision for a Live / Paused survey. */
export async function startInstrumentLiveEdit(instrumentId: string): Promise<IInstrumentLiveEditState> {
  const { data: envelope } = await apiClient.post<ApiResponse<IInstrumentLiveEditState>>(
    instrumentLiveEditPath(instrumentId),
  )
  if (!envelope?.data) {
    throw new Error('Live edit response missing data')
  }
  return envelope.data
}

/** BFP-1142 — drops unpublished edits; the published survey is untouched. */
export async function discardInstrumentLiveEdit(instrumentId: string): Promise<void> {
  await apiClient.delete(instrumentLiveEditPath(instrumentId))
}

/** BFP-1142 — applies the pending revision to the live survey. */
export async function republishInstrument(params: {
  instrumentId: string
  idempotencyKey?: string
}): Promise<IRepublishInstrumentResult> {
  const idempotencyKey = params.idempotencyKey ?? globalThis.crypto.randomUUID()
  const { data: envelope } = await apiClient.post<ApiResponse<IRepublishInstrumentResult>>(
    instrumentRepublishPath(params.instrumentId),
    undefined,
    { headers: { 'Idempotency-Key': idempotencyKey } },
  )
  if (!envelope?.data) {
    throw new Error('Republish response missing data')
  }
  return envelope.data
}
